export default (props, vars) =>
  !!vars?.useapplicationoffer2?.applicationOffer?.end_date;
